<template>
  <section class="page-map">
    <Map id="page-map-viz" 
      @update-data="updateData"
      @update-panel="updatePanel"
      ref="mapComponent" />

    <MapSidePanel 
      :panelState="panelState"
      :selectedEl="selectedEl"
      @reset-map="resetMap"      
      @update-panel="updatePanel" />    
  </section>
</template>

<script>
import Map from '@/components/ui/Map';
import MapSidePanel from '@/components/ui/MapSidePanel';

export default {
  name: 'MapPage',
  components: {
    Map,
    MapSidePanel,
  },
  data() {
    return {
      selectedEl: {},
      panelState: ''
    };
  },
  methods: {
    updateData(e) {
      this.selectedEl = e;
    },
    updatePanel(e) {
      this.panelState = e;     
    },
    resetMap() {
      this.$refs.mapComponent.resetMap();
    },   
  },
}
</script>

<style scoped lang="scss">
#page-map-viz {
  position: fixed;
  top: 0;
  height: calc(var(--vh, 1vh) * 100 );
  left: 0;
  right: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100 );
}
</style>